/**
 * @file Action Creator module for PickupForm Component
 * @author Mike Chacon
 */

import { getPickupBlocks } from "api/pickupBlocks";
import { createLocation } from "api/locations";
import { createPickup } from "api/pickups";
import history from "utils/history";

/*
 * Create Pickup Block Actions
 * */
import { createApiActions } from "utils/createApiActions";

export const pickupBlocksApi = new createApiActions({
  name: "SEARCH_PICKUP_BLOCKS",
  api: { get: getPickupBlocks },
});

export const donorLocationsApi = new createApiActions({
  name: "DONOR_LOCATIONS",
  api: { createUpdate: createLocation },
});

export const setFormData = (data) => ({
  type: "ADD_FORM_DATA_TO_STORE",
  data: data,
});

// Pass in array of keys that will be restored from the default state
export const resetFormData = (keys) => ({
  type: "REMOVE_FORM_DATA_FROM_STORE",
  data: keys,
});

export const resetForm = () => ({
  type: "RESET_FORM_DATA",
});

export const nextStep = (redirect = true) => {
  if (redirect) {
    history.push(
      `/schedule/${
        Number(
          history.location.pathname.substring(
            history.location.pathname.lastIndexOf("/") + 1
          )
        ) + 1
      }`
    );
  }

  return {
    type: "NEXT_STEP",
  };
};

export const previousStep = (redirect = true) => {
  if (redirect) {
    history.push(
      `/schedule/${
        Number(
          history.location.pathname.substring(
            history.location.pathname.lastIndexOf("/") + 1
          )
        ) - 1
      }`
    );
  }

  return {
    type: "PREVIOUS_STEP",
  };
};

// action that manually sets the step in the form flow
export const goToStep = (step, redirect = true) => {
  if (redirect) {
    history.push(`/donate/${step}`);
  }

  return {
    type: "GO_TO_STEP",
    data: step,
  };
};

// action that sets the type of flow for the form
// if the form flow is in it's initial state we will treat it differently
// this is needed to render the correct initial step of the form
export const enterInitialFlow = () => ({
  type: "ENTER_INITIAL_FLOW",
});

export const leaveInitialFlow = () => ({
  type: "LEAVE_INITIAL_FLOW",
});
